import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { ContentView } from '../components/ContentView';
import { ProfileView } from '../intakeForm/ProfileView';
import { ResponsiveFormProvider } from '../intakeForm/ResponsiveFormContext';
import { FittedLogo } from '../components/FittedLogo';
export const SignupScreen = () => {
    /**
     * debugOverrides are handy for localhost testing. They only gets passed-in if __DEV__ is true
     */
    const debugOverrides = {
        email: 'koutavasj+aw2@gmail.com',
        password: 'Password1!',
        confirmPassword: 'Password1!',
        fullName: 'Joe Bloe',
        birthDate: '01-02-1980',
        gender: 'M',
        phoneNumber: '603-555-1212',
        existingWeight: 220,
        idealWeight: 180,
        heightDisplay: "5'10",
        'beverage-4': true, // almond milk
        'dislike-1': true, // apple
        'goal-LoseWeight': true,
    };
    // ResponsiveFormProvider turns on the phone layout for this form only;
    // admin Add/Edit client screens share ProfileView and stay unchanged.
    return (<ContentView>
      <ScrollView style={styles.scroll} contentContainerStyle={styles.content} keyboardShouldPersistTaps="handled">
        <View style={styles.content}>
          <FittedLogo />
          <ResponsiveFormProvider>
            <ProfileView debugOverrides={__DEV__ ? debugOverrides : {}}/>
          </ResponsiveFormProvider>
        </View>
      </ScrollView>
    </ContentView>);
};
const styles = StyleSheet.create({
    scroll: {
        flex: 1,
    },
    content: {
        alignItems: 'center',
    },
});
